import {
  Grid,
  Paper,
  TableContainer,
  TextField,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import CustomButton from "../../../Components/CustomButton";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import { updateMenuDetailsAPI } from "../../../Store/Action/menu";
import Colors from "../../../theme/Colors";
  
  const UpdateMenu = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { editMenu } = location.state || {}
 
    useEffect(() => {
      setBreadcrumbs([
        { key: "1", href: "/userList", text: "Masters" },
        { key: "2", href: "/menu", text: "Menu" },
        { key: "3", href: "/menu/edit", text: "Update Menu" },
      ]);
    }, []);
  
    const {
      control,
      handleSubmit,
      formState: { errors },
    } = useForm();
    const [breadcrumbs, setBreadcrumbs] = useState([]);
  
    if (!editMenu) {
      return <div>No Menu details available.</div>;
    }
  
    const onSubmit = async (data) => {
       
      const requestData = {
        menu_id:editMenu.menu_id,
        menu_title: data?.menu_title,
        menu_slug: data?.menu_slug,
        menu_order: data?.menu_order,
        menu_parent_id: data?.menu_parent_id,
       
      };
      
      try {
        await dispatch(
          updateMenuDetailsAPI(requestData, (isSuccess, response) => {
            if (isSuccess?.status === true) {
              toast.success(response?.data?.message);
              navigate("/menu");
            } else {
              const errorMessage =
                response?.error?.message || Strings.somethingWentWrongError;
              toast.error(errorMessage);
            }
          })
        );
      } catch (error) {
        console.log("Error dispatching addProducts:", error);
        toast.error(Strings.somethingWentWrongError);
      }
    };
  
    return (
      <div style={mainContainer}>
        <LeftSideNav />
  
        <div style={leftNavContainer}>
          <div style={topBar}>
            <TopNavBar />
  
            <div style={pageTitle}>
              <h2>Menu</h2>
            </div>
  
            <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
          </div>
  
          <TableContainer component={Paper} style={tableContainer}>
            <p style={mainHeadingStyle}>Update Menu</p>
  
            <hr />
  
            <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography style={labelInfoStyle}>Menu Title</Typography>
                  <Controller
                    name="menu_title"
                    control={control}
                    defaultValue={editMenu.menu_title}
                    rules={{ required: Strings.productValueRequired }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Menu Title"
                        variant="outlined"
                        fullWidth
                        error={!!errors?.menuTitle}
                        helperText={
                          errors?.menuTitle ? errors?.menuTitle.message : ""
                        }
                        InputProps={{
                          style: inputTextStyle, // Set background color
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography style={labelInfoStyle}>Menu Slug</Typography>
                  <Controller
                    name="menu_slug"
                    control={control}
                    defaultValue={editMenu.menu_slug}
                    rules={{ required: Strings.productValueRequired }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Menu Slug"
                        variant="outlined"
                        fullWidth
                        error={!!errors?.menuSlug}
                        helperText={
                          errors?.menuSlug ? errors?.menuSlug.message : ""
                        }
                        InputProps={{
                          style: inputTextStyle, // Set background color
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography style={labelInfoStyle}>Menu Parent Id</Typography>
                  <Controller
                    name="menu_parent_id"
                    control={control}
                    defaultValue={editMenu.menu_parent_id}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Menu Parent Id"
                        variant="outlined"
                        fullWidth
                        error={!!errors?.menuParentId}
                        helperText={
                          errors?.menuParentId ? errors?.menuParentId.message : ""
                        }
                        InputProps={{
                          style: inputTextStyle, // Set background color
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography style={labelInfoStyle}>Menu Order</Typography>
                  <Controller
                    name="menu_order"
                    control={control}
                    defaultValue={editMenu.menu_order}
                    rules={{ required: Strings.productValueRequired }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Menu Order"
                        variant="outlined"
                        fullWidth
                        error={!!errors?.menuOrder}
                        helperText={
                          errors?.menuOrder ? errors?.menuOrder.message : ""
                        }
                        InputProps={{
                          style: inputTextStyle, // Set background color
                        }}
                      />
                    )}
                  />
                </Grid>
  
                <CustomButton handleSubmit={handleSubmit} label={Strings.Save} />
              </Grid>
            </form>
          </TableContainer>
        </div>
      </div>
    );
  };
  
  const mainContainer = {
    display: "grid",
    gridTemplateColumns: "20% 80%",
    height: "100vh",
    width: "100vw",
    overflowX: "hidden",
    overflowY: "hidden",
  };
  
  const leftNavContainer = {
    display: "grid",
    gridTemplateRows: "15% 80%",
    backgroundColor: "#F0F5FF",
  };
  
  const topBar = {
    backgroundColor: "white",
    height: "7vh",
    width: "100%",
  };
  
  const pageTitle = {
    marginLeft: "30px",
    justifyContent: "flex-start",
    display: "flex",
  };
  
  const tableContainer = {
    width: "70vw",
    border: "1px solid #ccc",
    borderRadius: "15px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    marginTop: "40px",
    paddingLeft: "20px",
    paddingRight: "20px",
    marginLeft: "30px",
  };
  
  const formStyle = {
    padding: "20px",
  };
  
  const mainHeadingStyle = {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
    color: Colors.black,
    display: "flex",
    marginTop: '20px',
    marginBottom: '20px'
  };
  
  const labelInfoStyle = {
    fontSize: 14,
    fontWeight: "400",
    fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
    color: Colors.black,
    display: "flex",
    marginBottom: "5px",
  };
  
  const inputTextStyle = {
    fontSize: 14,
    fontWeight: "400",
    fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
    color: Colors.darkGray,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    backgroundColor: Colors.lightBlue,
  };
  
  const btnStyle = {
    height: "40px",
    width: "12vh",
    borderRadius: "8px",
    border: "1px solid #4A505C",
    fontSize: 14,
    fontWeight: "700",
    fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
    color: Colors.black,
    marginTop: "10px",
  };
  
  export default UpdateMenu;
  